<template>
  <div class="card role">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col-md-3">
              <h3>Roles</h3>
            </div>
            <div class="col violetb">
              <i class="fas fa-user-graduate"></i>
              <span>04</span>
              Roles
            </div>
            <div class="text-right" v-if="isAdmin || isSuperAdmin">
              <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i></a>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "roles",
  data() {
    return {
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      isAdmin: false
    };
  },
  methods: {
     navigateListPage(){
      window.location.href = "/bidside/admin-roles";
    }
  },
  mounted() {
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        
        this.roleArray = role.map(item => {return  item.split("-")[1]});

        this.roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        this.roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
        this.roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
        this.roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
      }
    });
  }
};
</script>